import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const BUSINESS_EMAIL = 'lynsisevent@gmail.com';
const PHONE_NUMBER = '+17783165050';
const PHONE_DISPLAY = '+1 778 316 5050';
const INSTAGRAM_URL = 'http://instagram.com/lynsiseventandfloral';

function Footer(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <footer className="lf-footer prevent-select" translate="no">
      <div className="lf-editorial">
        <div className="row">
          <div className="col-lg-5 mb-4">
            <p className="lf-brand" style={{ fontSize: '1.55rem' }}>Lynsis Event &amp; Floral</p>
            <p className="mt-3" style={{ fontSize: '0.9rem', lineHeight: 1.5, color: 'rgba(245, 243, 237, 0.75)', maxWidth: '24rem' }}>
              {floral.footer.tagline[language]}
            </p>
            <a
              className="lf-btn-secondary lf-btn-on-dark mt-3"
              onClick={() => {
                const target = document.getElementById('contact');
                if (target) {
                  target.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              {floral.footer.beginInquiry[language]}
            </a>
          </div>
          <div className="col-lg-4 col-6 mb-4">
            <p className="lf-eyebrow" style={{ color: 'var(--lf-sage-light)' }}>{floral.footer.connect[language]}</p>
            <a className="d-block mt-3" style={{ fontSize: '0.85rem' }} href={`mailto:${BUSINESS_EMAIL}`}>{BUSINESS_EMAIL}</a>
            <a className="d-block mt-2" style={{ fontSize: '0.85rem' }} href={`tel:${PHONE_NUMBER}`}>{PHONE_DISPLAY}</a>
            <a
              className="d-block mt-2"
              style={{ fontSize: '0.85rem' }}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {floral.footer.instagram[language]}
            </a>
            <div className="d-flex mt-3" style={{ gap: '0.75rem' }}>
              <div style={{ width: '56px' }}>
                <img src="./img/qr_wechat.png" alt="WeChat QR code" style={{ width: '100%', background: '#fff' }} />
                <p className="mt-1" style={{ fontSize: '0.65rem', textAlign: 'center' }}>{floral.footer.wechat[language]}</p>
              </div>
              <div style={{ width: '56px' }}>
                <img src="./img/qr_xhs.png" alt="Xiaohongshu QR code" style={{ width: '100%', background: '#fff' }} />
                <p className="mt-1" style={{ fontSize: '0.65rem', textAlign: 'center' }}>{floral.footer.xiaohongshu[language]}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-6 mb-4">
            <p className="lf-eyebrow" style={{ color: 'var(--lf-sage-light)' }}>{floral.footer.serviceAreaHeading[language]}</p>
            <p style={{ fontSize: '0.85rem', lineHeight: 1.5, color: 'rgba(245, 243, 237, 0.75)', maxWidth: '18rem' }}>
              {floral.footer.serviceAreaText[language]}
            </p>
          </div>
        </div>
        <div className="lf-footer-copyright">
          {floral.footer.copyright[language]}
        </div>
      </div>
    </footer>
  );
}

export { Footer };
